<form class="sleek-form" (ngSubmit)="onSubmit()" [formGroup]="addStoreForm">
  <div class="form-section">
    <h3 class="section-title">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
        <circle cx="12" cy="10" r="3"></circle>
      </svg>
      Store Information
    </h3>

    <div class="form-grid">
      <div class="form-field">
        <label>Store Name <span class="required">*</span></label>
        <input type="text" formControlName="storeName" 
               class="form-input"
               [class.invalid]="addStoreForm.get('storeName')?.invalid && addStoreForm.get('storeName')?.touched"
               placeholder="Enter store name">
        <span class="error-message" *ngIf="addStoreForm.get('storeName')?.invalid && addStoreForm.get('storeName')?.touched">
          Store name is required (min 2 characters)
        </span>
      </div>

      <div class="form-field">
        <label>Email <span class="required">*</span></label>
        <input type="email" formControlName="storeEmail" 
               class="form-input"
               [class.invalid]="addStoreForm.get('storeEmail')?.invalid && addStoreForm.get('storeEmail')?.touched"
               placeholder="store@company.com">
        <span class="error-message" *ngIf="addStoreForm.get('storeEmail')?.invalid && addStoreForm.get('storeEmail')?.touched">
          Valid email is required
        </span>
      </div>

      <div class="form-field">
        <label>Address <span class="required">*</span></label>
        <input type="text" formControlName="storeAddress" 
               class="form-input"
               [class.invalid]="addStoreForm.get('storeAddress')?.invalid && addStoreForm.get('storeAddress')?.touched"
               placeholder="Street address">
        <span class="error-message" *ngIf="addStoreForm.get('storeAddress')?.invalid && addStoreForm.get('storeAddress')?.touched">
          Address is required
        </span>
      </div>

      <div class="form-field">
        <label>City <span class="required">*</span></label>
        <input type="text" formControlName="storeCity" 
               class="form-input"
               [class.invalid]="addStoreForm.get('storeCity')?.invalid && addStoreForm.get('storeCity')?.touched"
               placeholder="City">
        <span class="error-message" *ngIf="addStoreForm.get('storeCity')?.invalid && addStoreForm.get('storeCity')?.touched">
          City is required
        </span>
      </div>

      <div class="form-field">
        <label>Site / Market <span class="required">*</span></label>
        <select formControlName="siteLocation" 
                class="form-input"
                [class.invalid]="addStoreForm.get('siteLocation')?.invalid && addStoreForm.get('siteLocation')?.touched">
          <option value="" disabled>Select site</option>
          <option *ngFor="let opt of siteLocationOptions" [value]="opt.value">{{ opt.label }}</option>
        </select>
        <span class="error-message" *ngIf="addStoreForm.get('siteLocation')?.invalid && addStoreForm.get('siteLocation')?.touched">
          Site is required
        </span>
        <small class="form-hint">Which domain/market this store appears on (e.g. aruba, bonaire)</small>
      </div>

      <div class="form-field">
        <label>Phone <span class="required">*</span></label>
        <input type="tel" formControlName="storePhone" 
               class="form-input"
               [class.invalid]="addStoreForm.get('storePhone')?.invalid && addStoreForm.get('storePhone')?.touched"
               placeholder="+1 (555) 123-4567">
        <span class="error-message" *ngIf="addStoreForm.get('storePhone')?.invalid && addStoreForm.get('storePhone')?.touched">
          Phone number is required
        </span>
      </div>

      <div class="form-field full-width">
        <label>Description <span class="required">*</span></label>
        <textarea formControlName="storeDescription" 
                  class="form-input form-textarea"
                  [class.invalid]="addStoreForm.get('storeDescription')?.invalid && addStoreForm.get('storeDescription')?.touched"
                  rows="4"
                  placeholder="Describe this store, its features, and what makes it special..."></textarea>
        <span class="error-message" *ngIf="addStoreForm.get('storeDescription')?.invalid && addStoreForm.get('storeDescription')?.touched">
          Description is required (min 10 characters)
        </span>
      </div>
    </div>
  </div>

  <div class="form-actions">
    <button type="submit" 
            class="btn btn-primary" 
            [disabled]="addStoreForm.invalid || isLoading">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M12 20h9"></path>
        <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7.5 18.5 3 20l1.5-4.5L16.5 3.5z"></path>
      </svg>
      {{isLoading ? 'Creating...' : 'Add Store'}}
    </button>
    <button type="button" class="btn btn-secondary" [disabled]="isLoading" (click)="addStoreForm.reset()">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <polyline points="23 4 23 10 17 10"></polyline>
        <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
      </svg>
      Clear Form
    </button>
  </div>
</form>